module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07505_logo_200x200.b44eed77.png";